import { createModel } from "nyax";
import { Queue } from "src/models/queue";
import { createItemsEntityModel } from "src/store/itemsEntity";

export const QueueEntityModel = createModel(
  class extends createItemsEntityModel<Queue>((item) => item.id) {
    public selectors() {
      return {
        ...super.selectors(),
      };
    }
  }
);
